// 创建 el-menu-item
export function elMenuItem(createElement, menu,account) {
  return createElement('el-menu-item', { props: { index: menu.path }}, [
    ...menu.icon ? [
      createElement('i', { attrs: { class: `fa fa-${menu.icon}` }})
    ] : [],
    ...menu.icon === undefined & !menu.iconSvg ? [
      createElement('i', { attrs: { class: 'fa fa-file-o' }})
    ] : [],
    ...menu.iconSvg ? [
      createElement('d2-icon-svg', { props: { name: menu.iconSvg }})
    ] : [],
    createElement('span', { slot: 'title' },getMenuTitle(menu.title,account))
  ])
}

// 创建 el-submenu
export function elSubmenu(createElement, menu,account) {
  return createElement('el-submenu', { props: { index: menu.path }}, [
    ...menu.icon ? [
      createElement('i', { slot: 'title', attrs: { class: `fa fa-${menu.icon}` }})
    ] : [],
    ...menu.icon === undefined & !menu.iconSvg ? [
      createElement('i', { slot: 'title', attrs: { class: 'fa fa-folder-o' }})
    ] : [],
    ...menu.iconSvg ? [
      createElement('d2-icon-svg', { slot: 'title', props: { name: menu.iconSvg }})
    ] : [],
    createElement('span', { slot: 'title' }, menu.title || '未命名菜单'),
    ...menu.children.map((child, childIndex) => (child.children === undefined || child.children === null ? elMenuItem : elSubmenu).call(this, createElement, child,account))
  ])
}

 function getMenuTitle(menuTitle, account) {
  if(menuTitle){
    if(menuTitle=='利润表'){
      if(account && account.accountingStandard){
        if(account.accountingStandard == 3){
          menuTitle='业务活动表'
        }else if(account.accountingStandard == 4){
          menuTitle='收益及收益分配表'
        }
      }
    }
  }else{
    menuTitle = '未命名菜单'
  }
  return menuTitle
}
